export const AD_INVENTORY_CODE = {
  MARKETING_HOME_POPUP: "IN303",
} as const;

export const AD_MATERIAL_TYPE = {
  IMAGE: "image",
  TEXT: "text",
} as const;

export const AD_MATERIAL_SUB_TYPE = {
  TEXT: "text",
} as const;

export const AD_TRACKING_EVENT_KEY = {
  VIEWABLE_IMPRESSION: "vimp",
  CLICK: "click",
} as const;

export type AdTrackingEventKey =
  (typeof AD_TRACKING_EVENT_KEY)[keyof typeof AD_TRACKING_EVENT_KEY];

export interface AdSizeFormat {
  w: number;
  h: number;
}

export interface AdMaterial {
  id: string;
  type: string;
  subType?: string | null;
  text?: string | null;
  url?: string | null;
  sizeFormat?: AdSizeFormat | null;
}

export interface AdTrackingEventUrl {
  key: string;
  value: string;
}

export interface Ad {
  adId: string;
  inventoryId: number;
  inventoryCode: string;
  adType: string;
  dspType?: string | null;
  materials: AdMaterial[];
  landingUrl?: string | null;
  trackingEventUrls?: AdTrackingEventUrl[] | null;
  isTopFixed?: boolean;
  tier?: number;
  rank?: number;
}

export interface AdsResponse {
  requestId: string;
  ads?: Ad[];
  message?: string;
}

export interface GetAdsParams {
  inventoryCode: string;
  posTime: string;
  lat: string;
  lon: string;
}
